import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Spin, message, Button, Table, Tag, Row, Col } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import CopyableText from '../../components/CopyableText';
import { formatDateTime } from '../../utils/format';
import { getTransaction } from '../../services/explorerService';

const TransactionDetail = () => {
  const { txid } = useParams();
  const navigate = useNavigate();
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadTransactionDetail = async () => {
    setLoading(true);
    try {
      const data = await getTransaction(txid);
      setTransaction(data.transaction);
    } catch (error) {
      message.error('加载交易详情失败');
      console.error('Transaction detail error:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadTransactionDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [txid]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 0' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!transaction) {
    return (
      <Card>
        <p>交易不存在</p>
        <Button onClick={() => navigate('/dashboard/explorer')}>返回浏览器</Button>
      </Card>
    );
  }

  const inputs = transaction.ios ? transaction.ios.filter(io => io.direction === 'input') : [];
  const outputs = transaction.ios ? transaction.ios.filter(io => io.direction === 'output') : [];

  const ioColumns = [
    {
      title: '地址',
      dataIndex: 'address',
      key: 'address',
      render: (text) => <CopyableText text={text} />
    },
    {
      title: '金额',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => amount ? parseFloat(amount).toFixed(8) : '-'
    },
    {
      title: '资产',
      dataIndex: 'asset_symbol',
      key: 'asset_symbol',
      render: (symbol, record) => {
        if (record.asset_id && symbol) {
          return (
            <a 
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/dashboard/explorer/asset/${record.asset_id}`);
              }}
              style={{ color: '#1890ff', cursor: 'pointer' }}
            >
              {symbol}
            </a>
          );
        }
        return symbol || '-';
      }
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          返回
        </Button>
      </div>

      <Card title="交易详情" style={{ marginBottom: 16 }}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label="交易哈希">
            <CopyableText text={transaction.txid} />
          </Descriptions.Item>
          <Descriptions.Item label="状态">
            <Tag color={transaction.is_mined ? 'green' : 'orange'}>
              {transaction.is_mined ? '已确认' : '未确认'}
            </Tag>
          </Descriptions.Item>
          {transaction.block_height && (
            <Descriptions.Item label="区块高度">
              {transaction.block_id ? (
                <a 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/dashboard/explorer/block/${transaction.block_id}`);
                  }}
                >
                  {transaction.block_height}
                </a>
              ) : (
                transaction.block_height
              )}
            </Descriptions.Item>
          )}
          {transaction.block_hash && (
            <Descriptions.Item label="区块哈希">
              <CopyableText text={transaction.block_hash} />
            </Descriptions.Item>
          )}
          <Descriptions.Item label="费用">
            {transaction.fee ? parseFloat(transaction.fee).toFixed(8) : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="是否Coinbase">
            <Tag color={transaction.coinbase ? 'blue' : 'default'}>
              {transaction.coinbase ? '是' : '否'}
            </Tag>
          </Descriptions.Item>
          {transaction.message && (
            <Descriptions.Item label="附加信息">{transaction.message}</Descriptions.Item>
          )}
          <Descriptions.Item label="所属链">{transaction.chain_name}</Descriptions.Item>
          <Descriptions.Item label="时间">
            {formatDateTime(transaction.inserted_at)}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Card title={`输入 (${inputs.length})`} style={{ marginBottom: 16 }}>
            {inputs.length > 0 ? (
              <Table
                columns={ioColumns}
                dataSource={inputs}
                rowKey="id"
                pagination={false}
                size="small"
                scroll={{ x: 600 }}
              />
            ) : (
              <p style={{ textAlign: 'center', color: '#999', margin: '20px 0' }}>
                {transaction.coinbase ? 'Coinbase交易无输入' : '暂无输入'}
              </p>
            )}
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title={`输出 (${outputs.length})`} style={{ marginBottom: 16 }}>
            {outputs.length > 0 ? (
              <Table
                columns={ioColumns}
                dataSource={outputs}
                rowKey="id"
                pagination={false}
                size="small"
                scroll={{ x: 600 }}
              />
            ) : (
              <p style={{ textAlign: 'center', color: '#999', margin: '20px 0' }}>暂无输出</p>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TransactionDetail;
